import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import relationships from './relationships';

export const REGISTERS = {
  namespaced: true,
  state: {
    // Admin state
    registers: [],
    total: 0,
    selectedRegister: null,
    facilities: [],
    users: [],
    
    // Upload state
    uploadProgress: 0,
    uploadStatus: 'idle', // idle, uploading, processing, validating, importing
    validationResults: null,
    importResults: null,
    
    // Template state
    templates: [],
    currentMapping: null,
    
    // UI state
    loading: false,
    updateLoading: false,
    error: null,

    // Table options for viewer
    options: {
      itemsPerPage: 15,
      sortBy: ['name'],
      sortDesc: [false],
    },

    // Audit log state
    auditLogs: [],
    auditLogsTotal: 0,
    auditLogsLoading: false,
    auditLogDetail: null,
    auditLogDetailLoading: false,
    auditSidebarOpen: false,
    auditSidebarMode: 'register', // 'register' | 'row'
    auditRegisterId: null, // The register ID currently being audited (for filters)
    selectedRowForAudit: null,
    auditViewMode: 'summary', // 'summary' | 'detail'
    auditFilters: {
      page: 1,
      itemsPerPage: 20,
      actionType: null,
      actionCategory: null,
      userId: null,
      fromDate: null,
      toDate: null,
      sortBy: 'actionTimestamp',
      sortDesc: true
    },

    // API Data Source state
    apiDataSources: [],
    apiDataSourcesTotal: 0,
    selectedApiDataSource: null,
    apiDataSourceLoading: false,

    // API Wizard state
    apiWizardOpen: false,
    apiWizardStep: 1,
    apiWizardMode: 'create', // 'create' | 'edit'
    apiWizardConfig: {
      name: '',
      url: '',
      httpMethod: 'GET',
      requestBody: '',
      headers: [],
      auth: {
        authType: 0,
        apiKeyHeaderName: '',
        apiKeyValue: '',
        bearerToken: '',
        username: '',
        password: '',
        tokenUrl: '',
        clientId: '',
        clientSecret: '',
        scope: '',
      },
      responseDataPath: '',
      pagination: {
        type: 0,
        pageParamName: 'page',
        pageSizeParamName: 'pageSize',
        pageSizeValue: 100,
        offsetParamName: 'offset',
        limitParamName: 'limit',
        limitValue: 100,
        cursorParamName: 'cursor',
        cursorResponsePath: '',
      },
    },
    apiWizardTestResult: null,
    apiWizardPreviewData: null, // { headers: [], data: [], totalRecords }
    apiWizardMapping: null,
    apiWizardSchedule: {
      frequency: 0, // Manual
      hour: 0,
      minute: 0,
      dayOfWeek: 1,
      cronExpression: '',
      triggerImmediate: false,
    },

    // Execution history
    executionHistory: [],
    executionHistoryTotal: 0,
    executionHistoryLoading: false,
  },
  
  getters,
  mutations,
  actions,
  modules: {
    relationships,
  },
};
